import * as React from "react";
import { cn } from "@/lib/utils";
import { logoVector, logoVector2 } from "@/lib/assets";

type LogoProps = React.HTMLAttributes<HTMLDivElement> & {
  variant?: "full" | "symbol";
  imageSizes?: string;
};

export function Logo({ variant = "full", className, imageSizes, ...props }: LogoProps) {
  if (variant === "symbol") {
    const sizes = imageSizes ?? "40px";
    return (
      <div className={cn("relative flex items-center justify-center", className)} {...props}>
        <div className="relative flex h-full w-full items-center justify-center">
          {/* This is a simplified version - the full logo would have both vectors */}
          {/* dark: renders the mark solid white (admin dark theme; marketing
              surfaces never carry the .dark class). */}
          <img
            src={logoVector}
            alt="Evangelist"
            className="block h-full w-full max-h-full max-w-full object-contain dark:brightness-0 dark:invert"
            loading="eager"
            decoding="async"
            sizes={sizes}
          />
        </div>
      </div>
    );
  }

  const sizes = imageSizes ?? "(max-width: 767px) 160px, 240px";

  return (
    <div className={cn("relative flex items-center justify-center overflow-hidden", className)} {...props}>
      {/* Vector 1 - left portion. dark: renders solid white (admin dark theme;
          marketing surfaces never carry the .dark class). */}
      <div className="absolute bottom-0 left-0 right-[80.17%] top-0">
        <img
          src={logoVector}
          alt=""
          className="block h-full w-full object-contain dark:brightness-0 dark:invert"
          loading="lazy"
          decoding="async"
          sizes={sizes}
        />
      </div>
      {/* Vector 2 - right portion with text */}
      <div className="absolute inset-[18.45%_0.77%_8.8%_27.53%]">
        <img
          src={logoVector2}
          alt=""
          className="block h-full w-full object-contain dark:brightness-0 dark:invert"
          loading="lazy"
          decoding="async"
          sizes={sizes}
        />
      </div>
      <span className="sr-only">Evangelist</span>
    </div>
  );
}
